import { ArrowRight, Award } from 'lucide-react';
import StarRating from './StarRating';

const CTABox = ({ 
  title = 'Unser Testsieger 2026',
  provider = 'Northwest Registered Agent',
  rating = 4.9,
  highlights = [],
  ctaText = 'Jetzt starten',
  ctaLink = 'https://www.northwestregisteredagent.com',
  variant = 'default' // 'default' | 'sidebar' | 'inline'
}) => {
  const variantClasses = {
    default: 'card-highlight p-8',
    sidebar: 'card-highlight p-6',
    inline: 'bg-gradient-to-r from-teal-50 to-teal-100 border border-teal-200 rounded-sm p-6',
  };

  return (
    <div className={variantClasses[variant]} data-testid="cta-box">
      {/* Badge */}
      <div className="flex items-center gap-2 mb-4">
        <span className="badge-teal flex items-center gap-1">
          <Award className="w-3 h-3" />
          {title}
        </span>
      </div>

      {/* Provider Name */}
      <h3 className="font-heading font-bold text-xl text-navy-900 mb-3">
        {provider}
      </h3>

      {/* Rating */}
      <div className="mb-4">
        <StarRating rating={rating} size="md" />
      </div>

      {/* Highlights */}
      {highlights.length > 0 && (
        <ul className="space-y-2 mb-6">
          {highlights.map((highlight, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-slate-700">
              <span className="text-teal-600 font-bold">✓</span>
              {highlight}
            </li>
          ))}
        </ul>
      )}

      {/* CTA Button */}
      <a
        href={ctaLink}
        target="_blank"
        rel="nofollow sponsored noopener noreferrer"
        className="cta-primary w-full flex items-center justify-center gap-2"
        data-testid="cta-box-button"
      >
        {ctaText}
        <ArrowRight className="w-4 h-4" />
      </a>

      {/* Price info */}
      <p className="text-xs text-slate-500 text-center mt-3">
        Ab $39 + Staatsgebühren
      </p>
    </div>
  );
};

export default CTABox;
